/* eslint-disable angular/file-name */
/* eslint-disable angular/function-type */

angular
  .module('webtip.module')
  .directive('webtipDigitalChart', function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        items: '=',
        maxDate: '=',
        minDate: '=',
        syncZoom: '='
      },
      controller: function ($scope, $element, $attrs, $timeout, __env) {
        $scope.__env = __env;
        $scope.$watch("syncZoom", function (extremes) {
          if (!$scope.chart.series.length) return;
          //When min and max are undefined. This is a zoom reset event
          if (!extremes.min && !extremes.max) {
            $scope.chart.series[0].xAxis.chart.zoomOut();
            //If synced min or max has changed. Set extremes for this chart
          } else if (extremes.min !== $scope.chart.xAxis[0].min || extremes.max !== $scope.chart.xAxis[0].max) {
            $scope.chart.series[0].xAxis.setExtremes(extremes.min, extremes.max);
          }
        }, false);

        $scope.$watch("items", (newValue = {}) => {
          $scope.labels = [];
          const chart = $scope.chart;
          // empty existing chart
          while (chart.series.length) {
            chart.series[0].remove();
          }
          if (newValue.length === 0) {
            //reject("Not enough signals selected or digitalsignals data is empty");
            return;
          }

          let digitalSignals = [];
          $scope.labels = Object.keys(newValue).sort((a, b) => a.localeCompare(b));
          _.each($scope.labels, (signal, signalIndex) => {
            const pointsWithMetadata = $scope.items[signal];
            if (pointsWithMetadata.signalMetadata.signalType !== 'DIGITAL') return;

            $scope.labels[signal] = pointsWithMetadata.signalMetadata.name;
            const digitalSignalSeries = [{
              showInLegend: true,
              // Add all filters to name
              name: pointsWithMetadata.signalMetadata.name,
              pointStart: null,
              data: []
            }];


            let start = null;
            const data = pointsWithMetadata.data;
            const last = data.length - 1;

            data.forEach(point => {
              if (start === null) start = point;

              if (Math.abs(point[2] - start[2]) > 0.1) {
                digitalSignalSeries[0].data.push({
                  x: point[0],
                  x2: point[1],
                  y: signalIndex,
                  color: (point[2] > 0.1) ? '#002c65' : '#ffac00',
                  signalValue: point[2]
                });
                start = point;
              }
              if (point === data[last]) {
                digitalSignalSeries[0].data.push({
                  x: start[0],
                  x2: point[1],
                  y: signalIndex,
                  color: (start[2] > 0.1) ? '#002c65' : '#ffac00',
                  signalValue: start[2]
                });
              }
            });

            if (digitalSignalSeries[0].data.length !== 0) {
              digitalSignalSeries[0].marker = {
                enabled: true,
              };

              digitalSignals.push(digitalSignalSeries[0]);
            }
          });
          _.each(digitalSignals, (series, index) => {
            chart.addSeries(series);
          });
          chart.setSize(null, digitalSignals.length * 10 + 100);
          if (chart.yAxis[0]) {
            chart.yAxis[0].categories = $scope.labels;
          }
          $timeout(function () {
            $scope.chart.redraw();
            $scope.chart.reflow();
          }, 500);
        }, true);
      },
      template: '<div id="webtip-digital-chart" style="margin: 0 auto">not working</div>',
      link: function (scope, element, attrs) {
        if (scope.__env.profile === 'LU') {
          // Assumes that the RMM data in db is in UTC
          Highcharts.setOptions({
            time: {
              timezone:  DateTime.local().zoneName,
              useUTC: false,
              timezoneOffset: DateTime.local().offset
            }
          });
        } 
        scope.chart = new Highcharts.Chart({
          chart: {
            renderTo: "webtip-digital-chart",
            type: 'xrange',
            animation: false,
            zoomType: "x",
            events: {
              selection: function (event) {
                if (event && event.xAxis) {
                  const extremesObject = event.xAxis[0];
                  if (extremesObject.min && extremesObject.max) {
                    scope.syncZoom = extremesObject;
                  }
                }
              }
            },
          },
          title: {
            text: '',
          },
          tooltip: {
            formatter: function () {
              let html = "";
              for (const element of this.points) {
                const point = element;
                html += '<b>' + point.series.name + '</b> - ' +
                  DateTime.fromJSDate(new Date(point.x)).toFormat('dd.MM.yy HH:mm:ss.SSS') + ' to ' + DateTime.fromJSDate(new Date(point.x2)).toFormat('dd.MM.yy HH:mm:ss.SSS') + ` - Value: ${point.point.signalValue}` + '<br/>';
              }
              return html;
            },
            shared: true
          },
          exporting: {enabled: false},

          plotOptions: {
            line: {
              allowPointSelect: false,
            },
            series: {
              turboThreshold: 50000,
              marker: {
                enabled: false,
              },
              lineWidth: 10,
              //stacking: 'overlap',
              animation: false,
              step: 'left',
            },
          }, yAxis: {
            tickInterval: 1,
            reversed: true,
            title: {
              text: null
            },
            categories: [],
            labels: {
              visible: true,
              useHTML: true,
              style: {
                width: '80px',
                textOverflow: 'ellipsis',
                maxWidth: '80px',
                minWidth: '80px',
                whiteSpace: 'normal'
              },
              step: 1,
              formatter: ({pos}) => {
                return scope.labels[pos];
              }
            }
          }, xAxis: {
            crosshair: true,
            type: 'datetime',
            events: {
              setExtremes: function (event) {
                //This triggers when reset zoom is pressed. in reset the event min and max are undefined
                if (!event.min && !event.max) {
                  scope.syncZoom = event;
                }
              }
            },
          },

          legend: {
            enabled: false,
          },

          credits: {
            enabled: false,
          },
          series: []
        });
      }
    };
  });